import dayjs from 'dayjs'
export default {
  name: 'es-mycard-design-preview',
  filters: {
    formatDate (date) {
      return dayjs(date).format('YYYY/MM/DD HH:mm')
    }
  },
  data: () => ({
    comments: 'いつもララの声を聴きながら仕事をしているとテンションが上がってるよー！！すっごく感謝しているよ。これからも共にワンダーエージェント店を盛り上げていこうぜーー！！'
  }),
  created: function () {
  },
  computed: {
    backgroundImageNumber () {
      return this.$route.query.background_path
    },
    backgroundImagePath () {
      return require(`../../../static/mycard/background/${this.backgroundImageNumber}.png`)
    },
    character1FolderNumber () {
      return this.$route.query.character_1_folder_path
    },
    character1Number () {
      return this.$route.query.character_1_path
    },
    character2Number () {
      return this.$route.query.character_2_path
    },
    character1ImagePath () {
      return require(`../../../static/mycard/character1/${this.character1FolderNumber}/${this.character1Number}.png`)
    },
    character2ImagePath () {
      return require(`../../../static/mycard/character2/${this.character2Number}.png`)
    },
    timeStamp() {
      var d = new Date()
      var year  = d.getFullYear()
      var month = d.getMonth() + 1
      var day   = d.getDate()
      var hour  = (d.getHours() < 10) ? '0' + d.getHours()   : d.getHours()
      var min   = (d.getMinutes() < 10) ? '0' + d.getMinutes() : d.getMinutes()
      var sec   = (d.getSeconds() < 10) ? '0' + d.getSeconds() : d.getSeconds()
      return year +''+ month +''+ day +''+ hour +''+ min +''+ sec
    },
    setClassCommentFontSize () {
      const count = this.comments.length
      if (count <= 50) return "big"
      if (count <= 80) return "middle"
      return "small"
    }
  },
  methods: {
    goSendList () {
      this.$router.push({
        path: '/send_list',
        query: {
          'background_path': this.backgroundImageNumber,
          'character_1_folder_path': this.character1FolderNumber,
          'character_1_path': this.character1Number,
          'character_2_path': this.character2Number
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/es-mycard-design-preview.js